import React from "react"
import useWindowDimensions from "../../helpers/windowDimensions"
import { useQuery } from "@apollo/react-hooks"
import { gql } from "apollo-boost"
import withApolloClient from "../withApolloClient"
import styled from "styled-components"
import Carousel from "./carousel"

const HomepageCarouselBox = styled.div`
  width: 100%;
  padding: 0;
  // overflow: hidden;
`

const CarouselWrapperBox = styled.div`
  width: 100%;
  padding: 2.4rem 0 3.4rem 0;
  &:first-of-type {
    padding: 0 0 1.6rem 0;
    @media (min-width: 768px) {
      padding: 0 0 2rem 0;
    }
    @media (min-width: 1024px) {
      padding: 0 0 2.4rem 0;
    }
  }
  @media (min-width: 768px) {
    padding-bottom: 4rem;
  }
  @media (min-width: 1024px) {
    padding-bottom: 4.4rem;
  }
`

const HomepageCarousel = props => {
  const { width } = useWindowDimensions()
  const { data, refetch } = useQuery(gql`
    query CarouselQuery {
      getHomepageCarousel(limit: 15) {
        widget {
          _id
          name
          description
          order
          displayNameAsTitle
          base64
          base64_mobile
          bgPrimary
          bgSecondary
          isInHomePage
        }
        skus {
          _id
          commercialName
          currentPrice
          referencePrice
          salePrice
          primaryImageId
          discount
          brandName
          image {
            _id
            base64_500
          }
          rating
          motherSkuCode
          productName
          commercialName
        }
      }
    }
  `,
    { fetchPolicy: 'cache-and-network' }
  )

  const settings = {
    centerMode: false,
    infinite: false,
    slidesToShow: 1,
    speed: 500,
    rows: 2,
    slidesPerRow: 2,
    dots: true,
    arrows: false,
  }

  if (width > 1300) {
    settings.slidesPerRow = 5
    settings.rows = 1
  } else if (width > 1000) {
    settings.slidesPerRow = 4
    settings.rows = 1
  } else if (width > 960) {
    settings.rows = 1
    settings.slidesPerRow = 3
  } else if (width > 600) {
    settings.slidesPerRow = 3
  }
  if (
    data &&
    data.getHomepageCarousel &&
    data.getHomepageCarousel[0].skus.length === 0
  ) {
    refetch()
  }
  return (
    <HomepageCarouselBox>
      {data &&
        data.getHomepageCarousel &&
        data.getHomepageCarousel.map((widget, index) => {
          if (widget.widget.isInHomePage)
            return (
              <CarouselWrapperBox key={index}>
                <Carousel settings={settings} widget={widget} width={width} />
              </CarouselWrapperBox>
            )
        })}
    </HomepageCarouselBox>
  )
}

export default withApolloClient(HomepageCarousel, {
  client: "smClient",
})
